import React, { useContext, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { 
    Box,
    ClickAwayListener,
    Fade,
    List,
    Popper,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';
import ProjectContext from '../../contexts/ProjectContext';
import ItemList from "../menuitem/ItemList";
import SecondaryButton from "../buttons/SecondaryButton";

export default function WarnMobileFeaturesDialog(props) {
    const { open, anchorEl, setOpen } = props

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'))
    const isSm = useMediaQuery(theme.breakpoints.down('md'))
    const isMd = useMediaQuery(theme.breakpoints.down('lg'))
    const isLg = useMediaQuery(theme.breakpoints.down('xl'))

    // If breakpoint crossed, hide the popper to prevent weird behaviour due to loss of anchor
    useEffect(()=>{
        setOpen(false)
    }, [isSm])

    return (
        <React.Fragment>
        {   
            isXs || isSm
            ?
            <Popper
            id={open ? 'upload-popper' : undefined}
            open={open}
            anchorEl={anchorEl}
            transition
            disablePortal
            placement={'right-end'}
            style={{ zIndex: 1500 }}
            modifiers={[
                {
                    name: 'flip',
                    enabled: true,
                    options: {
                        altBoundary: false,
                        rootBoundary: 'document',
                        padding: 8,
                    },
                },
                {
                    name: 'preventOverflow',
                    enabled: false,
                    options: {
                        altAxis: false,
                        altBoundary: false,
                        tether: false,
                        rootBoundary: 'document',
                        padding: 8,
                    },
                },
            ]}
            >
            {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                    <Fade {...TransitionProps}>
                        <Box
                            width={'150px'}
                            height={'auto'}
                            // overflow={'scroll'}
                            display="flex"
                            flexDirection="column"
                            backgroundColor={'rgba(150,80,0,0.9)'}
                            sx={{
                                // border: '2px solid rgba(107, 164, 125, 0.3)',
                                borderRadius: '8px',
                                color: 'white',
                                padding: '20px',
                                marginLeft: '10px'
                            }}
                        >
                        Limited features are currently available on Konsol Mobile.
                        <br/>
                        To access all features use a laptop or desktop.
                        </Box>
                    </Fade>
                </ClickAwayListener>
            )}
            </Popper>

        :
        <></>
        }
        </React.Fragment>
    )
}